<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ editing ? 'Sửa' : 'Xem chi tiết' }} đơn vị</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getSyncSourceType(unit.syncSourceType) }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <!-- -đơn vị đang đăng nhập có phải là đơn vị đang sửa không trừ trường hợp admin, nếu là đơn vị đang sửa, trường Đơn vị cấp trên hiển thị label
                                -->
                                <b-form-group label="Đơn vị cấp trên:"
                                              label-for="parentId"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true"
                                              label-class="isAdmin ? '' : 'required'">
                                    <div v-if="(isAdmin || isEditParentId) && editing">
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="parentIdFeedback"
                                                      v-model="$v.unit.parentId.$model"
                                                      :state="$v.unit.parentId.$dirty ? !$v.unit.parentId.$error : null"></b-form-input>
                                        <unit-tree v-model="unit.parentId" :includeInactive="false" ref="unitTree" v-if="unitFlag" :syncSourceType="1"
                                                   aria-describedby="parentIdFeedback" :excludeBranches="unitId"
                                                   :state="$v.unit.parentId.$dirty? !$v.unit.parentId.$error : null"></unit-tree>
                                        <b-form-invalid-feedback id="parentIdFeedback" v-if="$v.unit.parentId.$error">
                                            Vui lòng chọn đơn vị
                                        </b-form-invalid-feedback>
                                    </div>
                                    <label class="col-form-label" v-else>{{ unit.parentUnitName == null ? "Không" : unit.parentUnitName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Mã đơn vị:"
                                              label-for="code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              :label-class="editing ? 'required' : ''">
                                    <!--<b-form-input type="text" id="code"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.unit.code.$model"
                                                  :state="($v.unit.code.$dirty? !$v.unit.code.$error : null) && ($v.codeUnique.$dirty? !$v.codeUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback" v-if="$v.unit.code.$error">
                                        Vui lòng nhập mã đơn vị
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback id="existingCodeFeedback" v-if="$v.codeUnique.$error">
                                        Mã đơn vị đã tồn tại
                                    </b-form-invalid-feedback>-->
                                    <template v-if="editing">
                                        <b-input-group>
                                            <b-form-input type="text" id="code"
                                                          class="remove-border-radio"
                                                          aria-describedby="codeFeedback"
                                                          v-model="$v.unit.code.$model"
                                                          :title="(unit.code && unit.parentId) ? 'Mã của danh mục cấp trên trực tiếp' :''"
                                                          :state="($v.unit.code.$dirty? !$v.unit.code.$error : null) && ($v.codeUnique.$dirty? !$v.codeUnique.$error : null)">
                                            </b-form-input>
                                            <b-input-group-append>
                                                <label class="col-form-label customlabel " v-if="countUnitChildren != null">({{countUnitChildren}})</label>

                                            </b-input-group-append>
                                            <b-form-invalid-feedback id="codeFeedback" v-if="$v.unit.code.$error">
                                                Vui lòng nhập mã đơn vị
                                            </b-form-invalid-feedback>
                                            <b-form-invalid-feedback id="existingCodeFeedback" v-if="$v.codeUnique.$error">
                                                Mã đơn vị đã tồn tại
                                            </b-form-invalid-feedback>

                                        </b-input-group>
                                    </template>
                                    <template v-else>
                                        <label class="col-form-label">{{ unit.code }}</label>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Mã QHNS:"
                                              label-for="code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="editing">
                                        <vue-typeahead-bootstrap v-model="unit.nationalBudgetCode" :title="nationalBudgetCodeTitle"
                                                                 :ieCloseFix="false"
                                                                 :data="listNationalBudgetCodes"
                                                                 :serializer="item => item.id + ' - ' + item.text"
                                                                 @hit="selectNationalBudgetCode"
                                                                 placeholder="Nhập mã QNHS"
                                                                 @input="lookupNationalBudgetCodes">
                                            <template slot="suggestion" slot-scope="{ data, htmlText }">
                                                <div class="d-flex align-items-center">
                                                    {{ data.id }} - {{ data.text }}
                                                </div>
                                            </template>
                                        </vue-typeahead-bootstrap>
                                    </template>
                                    <template v-else>
                                        <label class="col-form-label">{{ unit.nationalBudgetCode }}</label>
                                    </template>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Tên đơn vị:"
                                              label-for="name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              :label-class="editing ? 'required' : ''">
                                    <b-form-input type="text" id="name" v-if="editing"
                                                  aria-describedby="nameFeedback"
                                                  v-model="$v.unit.name.$model"
                                                  :state="($v.unit.name.$dirty? !$v.unit.name.$error : null) &&($v.nameUnique.$dirty? !$v.nameUnique.$error : null) ">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameFeedback" v-if="$v.unit.name.$error">
                                        Vui lòng nhập tên đơn vị
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback id="existingNameFeedback" v-if="!$v.unit.name.$error && $v.nameUnique.$error">
                                        Tên đơn vị đã tồn tại
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing" :title="unit.fullName">{{ unit.name }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Thuộc loại:"
                                              label-for="functionalUnitType"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-radio-group v-model="unit.functionalUnitType" name="functional-unit-Type-radio" v-if="editing" id="functionalUnitType" :options="listFunctionalUnitTypes">
                                    </b-form-radio-group>
                                    <label class="col-form-label" v-if="!editing">{{ unit.functionalUnitTypeName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>

                            <b-col md="6">
                                <b-form-group label="Phân loại đơn vị:"
                                              label-for="typeunit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              :label-class="editing ? 'required' : ''">
                                    <template v-if="editing">
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="unitTypeFeedback"
                                                      v-model="$v.unit.unitTypeId.$model"
                                                      :state="$v.unit.unitTypeId.$error ? false : null"></b-form-input>
                                        <treeselect id="typeunit"
                                                    ref="unitTypeTree"
                                                    v-model="unit.unitTypeId"
                                                    :max-height="390"
                                                    placeholder="Nhập phân loại đơn vị"
                                                    :options="unitTypeTree" />
                                        <b-form-invalid-feedback id="unitTypeFeedback">
                                            Vui lòng chọn phân loại đơn vị
                                        </b-form-invalid-feedback>
                                        <router-link v-if="isBTCUser" to="/master-data/unit-types/list">
                                            Cập nhật phân loại đơn vị
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        <label class="col-form-label">{{ unit.unitTypeName }}</label>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Chế độ hạch toán:"
                                              label-for="accountingregime"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <select2 style="width: 100% !important;" class="col-md-9" placeholder="--- Chọn hạch toán ---" v-if="editing"
                                             v-model="unit.accountingStandard"
                                             v-bind:options="listAccountingStandard"></select2>
                                    <label class="col-form-label" v-if="!editing">{{ unit.accountingStandardName }}</label>
                                </b-form-group>
                            </b-col>


                        </b-row>
                        <b-row>

                            <b-col md="6">
                                <b-form-group label="Cấp hành chính:"
                                              label-for="administrativeLevel"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-radio-group v-model="unit.administrativeLevel" name="administrative-level-radio" @change="test()" v-if="editing">
                                        <b-form-radio value="1">Trung ương</b-form-radio>
                                        <b-form-radio value="2">Địa phương</b-form-radio>
                                    </b-form-radio-group>
                                    <label class="col-form-label" v-if="!editing">{{ unit.administrativeLevel == 1 ? 'Trung ương' : 'Địa phương' }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Cấp đơn vị:"
                                              label-for="unitLevel"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :label-class="editing ? 'required' : ''"
                                              :horizontal="true">
                                    <template v-if="editing">
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="unitLevelFeedback"
                                                      v-model="$v.unit.unitLevelId.$model"
                                                      :state="($v.unit.unitLevelId.$dirty ? !$v.unit.unitLevelId.$error : null) && ($v.unitLevelValidation.$dirty? !$v.unitLevelValidation.$error : null)"></b-form-input>

                                        <div v-show="unit.administrativeLevel == 1">
                                            <select2 class="col-md-9" placeholder="--- Chọn cấp đơn vị ---"
                                                     v-if="unitLevelsCentral.length > 0"
                                                     v-model="unit.unitLevelId"
                                                     v-bind:options="unitLevelsCentral"
                                                     :state="($v.unit.unitLevelId.$dirty? !$v.unit.unitLevelId.$error : null) && ($v.unitLevelValidation.$dirty? !$v.unitLevelValidation.$error : false)"
                                                     allowClear="true"></select2>
                                        </div>
                                        <div v-show="unit.administrativeLevel != 1">
                                            <select2 class="col-md-9" placeholder="--- Chọn cấp đơn vị ---"
                                                     v-if="unitLevelsLocal.length > 0"
                                                     v-model="unit.unitLevelId"
                                                     v-bind:options="unitLevelsLocal"
                                                     :state="($v.unit.unitLevelId.$dirty? !$v.unit.unitLevelId.$error : null) && ($v.unitLevelValidation.$dirty? !$v.unitLevelValidation.$error : false)"
                                                     allowClear="true"></select2>
                                        </div>
                                        <b-form-invalid-feedback id="unitLevelFeedback" v-if="$v.unit.unitLevelId.$error">
                                            Vui lòng chọn cấp đơn vị
                                        </b-form-invalid-feedback>
                                        <b-form-invalid-feedback v-if="!$v.unit.unitLevelId.$error && $v.unitLevelValidation.$error">
                                            Cấp đơn vị không hợp lệ
                                        </b-form-invalid-feedback>
                                    </template>
                                    <template v-else>
                                        <label class="col-form-label">{{ unit.unitLevelName }}</label>
                                    </template>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Địa bàn:"
                                              label-for="region"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              :label-class="editing ? 'required' : ''">
                                    <template v-if="editing">
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="regionFeedback"
                                                      v-model="$v.unit.provinceId.$model"
                                                      :state="$v.unit.provinceId.$dirty ? !$v.unit.provinceId.$error : null"></b-form-input>
                                        <select2 style="width:100%" v-if="this.listProvinces.length > 0 || flag"
                                                 placeholder="--- Chọn tỉnh/thành phố ---" id="region"
                                                 aria-describedby="regionFeedback"
                                                 v-model="$v.unit.provinceId.$model"
                                                 allowClear="true"
                                                 v-bind:options="listProvinces"></select2>
                                        <b-form-invalid-feedback id="regionFeedback">
                                            Vui lòng chọn tỉnh/thành phố
                                        </b-form-invalid-feedback>
                                        <div style="margin:10px 0 10px 0;">
                                            <b-form-input type="text" style="display: none"
                                                          aria-describedby="regionFeedback"
                                                          v-model="$v.unit.districtId.$model"
                                                          :state="$v.unit.districtId.$dirty ? !$v.unit.districtId.$error : null"></b-form-input>
                                            <select2 style="width:100%;" v-if="this.listDistricts.length > 0 || flag"
                                                     placeholder="--- Chọn quận/huyện ---"
                                                     v-model="unit.districtId"
                                                     allowClear="true"
                                                     v-bind:options="listDistricts"></select2>
                                            <b-form-invalid-feedback id="regionFeedback">
                                                Vui lòng chọn quận/huyện
                                            </b-form-invalid-feedback>
                                        </div>
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="regionFeedback"
                                                      v-model="$v.unit.wardId.$model"
                                                      :state="$v.unit.wardId.$dirty ? !$v.unit.wardId.$error : null"></b-form-input>
                                        <select2 style="width:100%" v-if="this.listWards.length > 0 || flag"
                                                 placeholder="--- Chọn xã/phường ---"
                                                 v-model="unit.wardId"
                                                 allowClear="true"
                                                 v-bind:options="listWards"></select2>
                                        <b-form-invalid-feedback id="regionFeedback">
                                            Vui lòng chọn xã/phường
                                        </b-form-invalid-feedback>
                                    </template>
                                    <template v-else>
                                        <label class="col-form-label">{{ unit.regionName }}</label>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Địa chỉ:"
                                              label-for="address"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-textarea id="textarea" v-if="editing"
                                                     v-model="unit.address"
                                                     placeholder="Nhập số nhà, đường phố, tổ/ thôn/ xóm"
                                                     rows="5"
                                                     max-rows="5"></b-form-textarea>
                                    <label class="col-form-label" v-if="!editing">{{ unit.address }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Số điện thoại:"
                                              label-for="phone"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input type="text" id="phone" v-if="editing"
                                                  v-model="unit.phoneNumber"
                                                  placeholder="">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ unit.phoneNumber }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Fax:"
                                              label-for="fax"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <b-form-input type="text" id="fax" v-if="editing"
                                                  v-model="unit.fax">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ unit.fax }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" v-if="!editing">
                                <b-form-group label="Mã QHNS:"
                                              label-for="phone"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true">
                                    <label class="col-form-label">{{ unit.nationalBudgetCode }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">

                            </b-col>
                        </b-row>
                        <div class="text-center">
                            <b-button type="submit" variant="primary" v-if="editing && authorize(['ManageUnit'])">Lưu</b-button>
                            <b-button type="button" variant="secondary" :to="{ path: '../' }">Quay lại</b-button>
                        </div>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { required, requiredIf, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    import { mixins } from '@/shared/mixins'
    import { debounce } from 'lodash';
    import { type } from 'jquery';
    var checkExistCode = _.debounce(function (vm) {
        vm.checkExistCode();
    }, 1000);

    export default {
        name: 'EditUnit',
        mixins: [validationMixin, mixins],
        data() {
            return {
                provinceFlag: false,
                districtFlag: false,
                wardFlag: false,
                unitFlag: false,
                codeUnique: 'ok',
                nameUnique: 'ok',
                //quyetpt -- bawts rang buoc cap don vi truc thuoc va cap don vi hien tai
                unitLevelValidation: 'ok',
                unit: {
                },
                listFunctionalUnitTypes: [
                    { text: 'Đơn vị tổng hợp', value: 1 },
                    { text: 'Đơn vị đăng ký', value: 2 }
                ],
                listProvinces: [],
                listDistricts: [],
                listWards: [],
                listUnitType: [],
                isEditParentId: true,
                isLoad: false,
                countUnitChildren: null,
                editing: this.$route.meta.editing,
                listNationalBudgetCodes: [],
                nationalBudgetCodeTitle: null
            }
        },
        computed: {
            flag() {
                //neeus ban ghi chua co region
                if (this.unit.regionId == null) {
                    this.districtFlag = true;
                    this.wardFlag = true;
                }
                else {
                    //ban ghi co roi
                    if (this.unit.districtId == null) {//quan huyen null thif show
                        this.districtFlag = true;
                    } else {
                        this.districtFlag = false;
                    }
                    if (this.unit.wardId == null) {//xa phuong null thi show
                        this.wardFlag = true;
                    }
                    else {
                        this.wardFlag = false;
                    }
                }
                return this.unitFlag && this.provinceFlag && this.districtFlag && this.wardFlag;
            },
            unitId() {
                return this.$route.params.unitId;
            },
            ...mapState({
                unitLevels: (state, getters) => state.common.unitLevels,
                unitLevelsCentral: (state, getters) => state.common.unitLevelsCentral,
                unitLevelsLocal: (state, getters) => state.common.unitLevelsLocal,
                unitTypeTree: (state, getters) => getters.unitTypeTree,
                listAccountingStandard: (state, getters) => state.common.listAccountingStandard,
            })
        },
        validations: {
            unit: {
                name: { required },
                code: { required },
                provinceId: { required },
                districtId: { required },
                wardId: { required },
                unitTypeId: { required },
                unitLevelId: { required },
                parentId: {
                    required: requiredIf(function () {
                        return !this.isAdmin;
                    })
                }
            },
            codeUnique: { required },
            nameUnique: { required },
            unitLevelValidation: { required },
        },
        watch: {
            'unit.provinceId'(newVal) {
                this.loadDistricts();
            },
            'unit.districtId'(newVal) {
                this.loadWards();
            },
            'unit.wardId'(newVal) {
            },
            'unit.code'(newVal) {
                checkExistCode(this);
            },
            'unit.unitLevelId'(newVal) {
                this.checkUnitLevel();
            },
            'unit.parentId'(newVal) {
                this.checkUnitLevel();
                if (newVal && this.unitFlag && this.isLoad) {
                    this.getCountUnitChildren();
                    this.unit.code = this.$refs.unitTree.$refs.treeUnit.selectedNodes[0].raw.code;
                }
                else {
                    this.countUnitChildren = null;
                }
            },
            'unit.unitTypeId'(val) {
                if (val && this.isLoad) {
                    this.loadAccountingStandardByUnitTypeId();
                }
            }
        },
        created() {
            this.loadUnitDetail();
            this.loadProvinces();
            if (this.$store.state.identity.manageUnitIds.indexOf(this.unitId) != -1) {
                this.isEditParentId = false;
            }
            else {
                this.isEditParentId = true;
            }
        },
        methods: {
            selectNationalBudgetCode(item) {
                this.nationalBudgetCodeTitle = item.id + ' - ' + item.text;
                this.unit.nationalBudgetCode = item.id;
            },
            lookupNationalBudgetCodes: debounce(function () {
                if (!this.unit.nationalBudgetCode && this.unit.nationalBudgetCode.length < 3) return;

                var vm = this;
                this.$services.get(`lookup/units/national-budget-codes?text=${this.unit.nationalBudgetCode}&syncSourceType=${this.unit.syncSourceType}`, null, { showLoading: false }).done(response => {
                    vm.listNationalBudgetCodes = response;
                })
            }, 500),
            checkUnitLevel() {
                var vm = this;
                if (this.unit.parentId && this.unit.unitLevelId) {
                    this.$services.get(`lookup/units/${this.unit.parentId}/unitlevel`, null, { showLoading: false }).done(id => {
                        if (parseInt(vm.unit.unitLevelId) >= parseInt(id)) {
                            vm.unitLevelValidation = "ok";
                        } else {
                            vm.unitLevelValidation = '';
                        }
                    });
                } else {
                    vm.unitLevelValidation = "ok";
                }
            },
            save() {
                this.$v.$touch();
                var vm = this;

                vm.$services.get(`master-data/units/existing-name?id=${this.unitId}&parentId=${this.unit.parentId || ''}`, { name: this.unit.name }).done((response) => {
                    if (response) {
                        this.nameUnique = "";
                    } else {
                        this.nameUnique = "required";
                    }

                    if (!vm.$v.$invalid) {
                        vm.$services.put(`master-data/units/${vm.unitId}`, vm.unit).done(() => {
                            vm.$toastr.s('Cập nhật đơn vị thành công');
                            vm.$store.dispatch('loadDefaultUnitTreeOptions').then(() => {
                                vm.$router.push({ path: '../' });
                            });
                        });
                    }
                });

            },
            loadProvinces() {
                var vm = this;
                this.$services.get(`lookup/regions/list?provinceId=&districtId=`, null).done((data) => {
                    vm.listProvinces = data;
                    vm.provinceFlag = true;
                });
            },
            loadDistricts() {
                var vm = this;
                if (this.unit.provinceId) {
                    this.$services.get(`lookup/regions/list?provinceId=${this.unit.provinceId}&districtId=`, null).done((data) => {
                        vm.listDistricts = data;
                        vm.districtFlag = true;
                    });
                } else {
                    this.listDistricts = [];
                }
            },
            loadWards() {
                if (this.unit.districtId) {
                    var vm = this;
                    this.$services.get(`lookup/regions/list?provinceId=${this.unit.provinceId}&districtId=${this.unit.districtId}`, null).done((data) => {
                        vm.listWards = data;
                        vm.wardFlag = true;
                    });
                } else {
                    this.listWards = [];
                }
            },
            loadUnitDetail() {
                var vm = this;
                return this.$services.get(`master-data/units/${this.unitId}`).done(unit => {
                    vm.unit = unit;
                    vm.unitFlag = true;
                    setTimeout(() => {
                        vm.isLoad = true;
                    }, 2000);
                });
            },
            checkExistCode() {
                if (this.unit.code != null || this.unit.code != "") {
                    var vm = this;
                    vm.$services.get(`master-data/units/existing-code?id=${this.unitId || ''}`, { code: this.unit.code, parentId: this.unit.parentId || '' }, { showLoading: false }).done((response) => {
                        if (response) {
                            this.codeUnique = "";
                        } else {
                            this.codeUnique = "required";
                        }
                    });
                }
            },
            getCountUnitChildren() {
                var vm = this;
                this.$services.get(`lookup/units/${this.unit.parentId}/children/build-code`, null, { showLoading: false }).done((response) => {
                    vm.countUnitChildren = response;
                });
            },
            loadAccountingStandardByUnitTypeId() {
                var vm = this;
                this.$services.get(`lookup/unit-types/${vm.unit.unitTypeId || ''}/accounting-standard`, null, { showLoading: false }).done((response) => {
                    vm.unit.accountingStandard = response;
                });
            },
            test() {
                var vm = this;
                console.log(vm.unit.unitLevelId);
                console.log(vm.unit);
            }
        }
    }
</script>
<style scoped>
    .mt-10 {
        margin-top: 10px;
    }

    .mg-10 {
        margin-left: 10px;
        margin-right: 10px;
    }

    .customlabel {
        width: 30px;
        text-align: center;
    }

    .remove-border-radio {
        border-bottom-right-radius: 0.25rem !important;
        border-top-right-radius: 0.25rem !important;
    }
</style>
